// extracted by css-extract-rspack-plugin
export default {"root":"l3lzA","open":"GuCbq"};